import request from "../../helpers/request";
import { getUser } from "../../helpers/user";

interface IListUsersRequest {
  idLoja: string,
  idRegional: string,
  nivel: number,
  onlyAdm?: boolean
}

const listUsersFilters = async ({ idLoja, idRegional, nivel, onlyAdm }: IListUsersRequest) => {
  let tipoId = "geral"; 
  let id = "0";
  let ativo = "0";

  if (nivel >= 7 && nivel <= 9) {
    if (onlyAdm) {
      tipoId = "adm";
      id = "0";
    } else if (idLoja) {
      tipoId = "idLoja";
      id = idLoja;
    } else if (idRegional) {
      tipoId = "idRegional";
      id = idRegional;
    }
  } else if (nivel === 5) {
    const { usuario } = getUser();
    if (idLoja) {
      tipoId = "idLoja";
      id = idLoja;
    } else {
      tipoId = "idCoordenador";
      id = `${usuario.id}`;
    }
  }

  const url = `/Usuario/getUsuariosFiltros?tipoId=${tipoId}&id=${id}&ativo=${ativo}`;
    
  try {
    const result = await request({ url });
    console.log("Resposta da API listUsers:", result);
    return result.data;
  } catch (err) {
    throw err;
  }
}

export const listUsersByLoja = async ({ idLoja }: any) => {
  const url = `/Usuario/getUsuariosIdLoja?idLoja=${idLoja}&ativo=1`

  try {
    const result = await request({ url })
    return result.data
  } catch (err) {
    throw err
  }
}

export const listUsers = async () => {
  const url = `/Usuario/getUsuarios`

  try {
    const result = await request({ url })
    return result.data
  } catch (err) {
    throw err
  }
}

export default listUsersFilters